import ResizableForm from '../../../../spine-cms-vue/src/components/mixins/ResizableForm.js';
import ComponentWithMetadataRelationMixin from "./mixins/ComponentWithMetadataRelationMixin";

Vue.asyncComponent('bp-metadata-form',{
    mixins: [ResizableForm,ComponentWithMetadataRelationMixin],
    props: {
        metadataId: {
            type: String,
            required: true
        },
        metadataHandler: {
            type: Object,
            required: true
        },
        placeholderHandler: {
            type: Object,
            required: false
        },
        metadataIndex: {
            type: Number|String
        }
    },
    data() {
        return {
            loading: false,
            activeMetaData: null,
            formData: null,
        }
    },
    computed: {
        /**
         * Blueprint id out of the url
         * @returns {any}
         */
        blueprintId() {
            return this.$route.params.blueprintId;
        },
        /**
         * Vertical id
         * Get the vertical id from the query params
         * @return {*}
         */
        verticalId() {
            return this.$route.query.verticalId;
        },
        /**
         * Get the version id from the query params
         * @return {any}
         */
        versionId() {
            return this.$route.query.versionId;
        },
        /**
         * Get the url for this metadata form
         * @returns {string}
         */
        formUrl() {
            return this.metadataHandler.getMetadataFormUrl(this.metadataId, this.blueprintId, this.verticalId, this.versionId);
        },
        /**
         * Get the url for this metadata form to save
         * @returns {string}
         */
        saveFormUrl() {
            return this.metadataHandler.getSaveMetadataFormUrl(this.metadataId, this.blueprintId, this.verticalId, this.versionId);
        },
        /**
         * Uniquge id for the width in localstorage
         * @return {string}
         */
        localStorageWidthId() {
            return 'editor-metadata-width';
        },
        /**
         * Check if the metadataIndex is new
         * @return {boolean}
         */
        isNew() {
            return this.metadataIndex === 'new';
        }
    },
    methods: {
        /**
         * notify the parent component that we have saved this form
         * and close this form
         */
        save(data) {
            this.$emit('saved', {id: this.metadataId, settings: data.settings});
        },
        /**
         * Close the stacked window by going back
         */
        triggerClose() {
            this.$emit('close');
        },
        /**
         * Set the active mete data
         *
         * @returns {Promise<void>}
         */
        async setActiveMetaData() {
            this.loading = true;
            // If we aren't adding a new meta data item
            // try to get the metadata item from the current selected items because we need its values
            this.activeMetaData = this.isNew
                    ? null
                    :await this.metadataHandler.getMetadataByIdAndIndex(this.metadataId, this.metadataIndex);

            // If we can not find the metadata in the current selected metadata items
            if (! this.activeMetaData) {
                // we get the metaData item from the supported items
                this.activeMetaData = await this.metadataHandler.getSupportedMetadataById(this.metadataId);
            }

            this.loading = false;
        },
        /**
         * Get the formData needed for the form
         * @returns {Promise<void>}
         */
        async getFormData() {
            let param = {
                locale: this.$localeHandler.getActiveLocale()
            };
            this.loading = true;
            try {
                const data = {
                    formValues : this.activeMetaData?.settings?.values
                };
                const placeholders = await this.placeholderHandler?.getPlaceholders();
                this.formData = await this.$post(this.formUrl, data, param);
                this.formData.form.controlWidgets.widgets.forEach(widget => {
                    widget.placeholders = placeholders;
                });

                this.loading = false;
            } catch (error) {
                console.log(error);
            }
        }
    },
    async created() {
        await this.setActiveMetaData();

        if (this.activeMetaData.settings.hasForm) {
            this.getFormData();
        }
    }
}, 'blueprints/meta/bp-metadata-form.html');